import { merchantDashboardIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const deleteMerchantDashboard = {
  name: "deleteMerchantDashboard" as const,
  input: z.object({ dashboardId: merchantDashboardIdFormat.schema }),
  output: z.object({}),
};
